module.exports = __webpack_public_path__ + "static/img/戴防护手套.6b80bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/戴防护手套.png
// module id = NElj
// module chunks = 1